export var EDocumentCustomFilter;
(function (EDocumentCustomFilter) {
    EDocumentCustomFilter["Active"] = "ACTIVE";
    EDocumentCustomFilter["Archived"] = "ARCHIVED";
    EDocumentCustomFilter["ExcludeInternalDocuments"] = "EXCLUDE_INTERNAL_DOCUMENTS";
})(EDocumentCustomFilter || (EDocumentCustomFilter = {}));
